import { deepCopy } from "@soft-db/soft-utils";
import { v4 as uuidv4 } from "uuid";
import { createPluginOptions } from "../create-plugin-options";
import { DataStyle } from "../type";

export type CommentBarCommentOptions = {
	id: string;
	style: DataStyle;
};

const defaultDataStyle = createPluginOptions<DataStyle>()({
	color: "yellow",
	lineWidth: "xLarge",
	antialiasing: false,
	lineDashStyle: "full",
	point: {
		visible: true,
		shape: "circle",
		size: "medium",
	},
});

export const defaultCommentBarDataOptions = createPluginOptions()({
	id: uuidv4(),
	style: deepCopy(defaultDataStyle),
});

export type CommentBarDataOptions = typeof defaultCommentBarDataOptions;
